/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Unsigned

1 = Signed

2 = Declined

3 = Internally Approved

4 = Not Applicable


 */
export type SignatureRequestUserStatus =
  (typeof SignatureRequestUserStatus)[keyof typeof SignatureRequestUserStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignatureRequestUserStatus = {
  Unsigned: 0,
  Signed: 1,
  Declined: 2,
  InternallyApproved: 3,
  NotApplicable: 4,
} as const;
